import { FlatTreeControl } from '@angular/cdk/tree';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { DragDropService } from '@app/shared/services/drag-drop/drag-drop.service';
import { InboxSettingsService } from '@app/shared/services/settings/inbox-settings/inbox-settings.service';
import { environment } from '@env/environment';
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';
import { ToastrService } from 'ngx-toastr';
import { element } from 'protractor';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'mobile-delivery-list-file',
  templateUrl: './mobile-delivery-list-file.component.html',
  styleUrls: ['./mobile-delivery-list-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileDeliveryListFileComponent implements OnInit, OnDestroy {
  @Output() moveNextPreviousEvent = new EventEmitter<any>();
  @Input() data;
  @Input() origin = 'onboarding';
  fileListDataTree = [];
  fileList = [];
  loginStateObject;
  screenWidth: number;
  resizeObservable$: Observable<Event>;
  progressdata = [];
  hasFile = false;
  completedCount = 0;
  loadOnce = true;
  isLoading = true;
  FileUploadedLimit = 30;
  FiletListDataList: Array<any> = [];
  subscription: Subscription = new Subscription();
  showLader;
  folderList = [];

  loadingItems = [{ id: 1 }, { id: 2 }, { id: 3 }];

  constructor(
    private dragDropService: DragDropService,
    private cd: ChangeDetectorRef,
    private _inboxService: InboxSettingsService,
    private toastr: ToastrService,
    private loginService: LoginStoreEffects
  ) {
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        this.loginStateObject = { ...state.data };
        if (state.data.id) {
          this.loadOnce = false;
          this.getInboxData(state.data.id);
        }
      })
    );
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  refreshFile() {
    this.getInboxData(this.loginStateObject.id);
  }
  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );
  }

  toggleFilterItem(event, file) {
    file.checked = event.source.checked;
    this.cd.detectChanges();
  }
  // method to get inbox data
  getInboxData(userId: number) {
    this.subscription.add(
      this._inboxService.getInboxData(userId).subscribe(
        (result: any) => {
          // stop loading
          this.fileList = [];
          result?.data.forEach((element) => {
            if (element.origin == 'mobile') {
              this.fileList.push({
                ...element,
                name: element.file_name,
                status: 'success',
                size: element.size,
                checked: true,
                type: '',
              });
            } else if (element.origin == 'onboarding') {
              this.fileList.push({
                name: element.file_name,
                ...element,
                status: 'success',
                size: element.size,
                checked: false,
                type: '',
              });
            }
          });
          try {
            this.fileList = this.fileList.sort((a, b) => {
              const dateA = new Date(a.updated_at);
              const dateB = new Date(b.updated_at);

              // Compare dates
              if (dateA > dateB) {
                return -1;
              }
              if (dateA < dateB) {
                return 1;
              }
              return 0;
            });
          } catch (error) {}
          this.completedCount = this.fileList.length;
          this.isLoading = false;
          this.cd.detectChanges();
        },
        (error: any) => {}
      )
    );
  }

  submitForm() {
    this.moveNextPreviousEvent.next({ status: 'forward', id: this.data.id });
  }

  backForm() {
    this.moveNextPreviousEvent.next({ status: 'backward' });
  }

  async uploadFileToS3WithWorkerPresignUrl(data: any) {
    try {
      const session = await fetchAuthSession();
      const idToken = session.tokens?.idToken?.toString();

      const token = `Bearer ${idToken}`;
      data.token = token;
      data.url = `${environment.apiUrl}/api/vault/inbox-file-upload`;
      // ... rest of the method
    } catch (error) {
      // ... error handling
    }
  }

  async uploadFileToS3WithWorkerS3Image(data: any) {
    try {
      const session = await fetchAuthSession();
      const idToken = session.tokens?.idToken?.toString();

      const token = `Bearer ${idToken}`;
      data.token = token;
      data.url = `${environment.apiUrl}/api/vault/inbox-file-upload`;
      // ... rest of the method
    } catch (error) {
      // ... error handling
    }
  }

  async uploadFileToS3WithWorkerStatusUpdate(data: any) {
    try {
      const session = await fetchAuthSession();
      const idToken = session.tokens?.idToken?.toString();

      const token = `Bearer ${idToken}`;
      data.token = token;
      data.url = `${environment.apiUrl}/api/vault/inbox-file-upload-status`;
      // ... rest of the method
    } catch (error) {
      // ... error handling
    }
  }
}
